const FACEBOOK_APP_ID = "1863257657641596";

export function FacebookSDK() {
  return new Promise((resolve, reject) => {
    if (window.FB) {
      resolve();
      return;
    }

    window.fbAsyncInit = function () {
      console.log("🧠 fbAsyncInit triggered");
      try {
        window.FB.init({
          appId: FACEBOOK_APP_ID,
          cookie: true,
          xfbml: true,
          version: "v22.0",
        });
        console.log("✅ FB SDK Initialized");
        resolve();
      } catch (error) {
        console.error("❌ FB.init failed:", error);
        reject(error);
      }
    };

    const scriptId = "facebook-jssdk";
    if (document.getElementById(scriptId)) {
      return;
    }

    const script = document.createElement("script");
    script.id = scriptId;
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    script.defer = true;
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

// export function fbLogin() {
//   return new Promise((resolve, reject) => {
//     window.FB.login(
//       (response) => {
//         resolve(response);
//       },
//       { scope: "public_profile,email" }
//     );
//   });
// }


export function fbLogin() {
  return new Promise((resolve, reject) => {
    if (!window.FB) {
      reject(new Error("FB SDK not initialized"));
      return;
    }

    window.FB.login(
      function (response) {
        console.log("🔐 FB.login response:", response);
        resolve(response);
      },
      {
        scope: 'pages_show_list,pages_read_engagement,business_management,public_profile,email,leads_retrieval'
        // response_type: "code",
        // config_id: "678682268508134",
        // override_default_response_type: true,
      }
    );
  });
}